<template>
  <!-- content -->
  <div class="content">
    <div class="title">
      <span class="fastReg">公司已注册</span>
      <span class="yourCompany">{{ company }}{{ contentReg }}</span>
      <span class="fastReg companyReg">或者注册新公司</span>
    </div>
    <input
      maxlength="36"
      type="text"
      class="text"
      v-model="newCompany.supplierName"
      placeholder="请填写公司全称"
      @input="checkSupplierName"
    />
    <el-button class="errorbtn" dangerouslyUseHTMLString="false"
      >错误</el-button
    >
    <button class="regUpload" @click="goPage">立即注册</button>
    <!-- </div> -->
  </div>
</template>

<script>
import { Message } from "element-ui";
import { getReguser, getCompany } from "@/api/register";
// import { getCheckInfo } from "@/api/register";
export default {
  data() {
    return {
      contentReg: "",
      //message高度
      messageHeight: null,
      company: "",
      temporyName: "",
      newCompany: {
        supplierName: ""
      },
      checkOut: {
        name: "",
        regType: "2",
        supplierName: "",
        mobile: ""
      }
    };
  },
  mounted() {
    this.getBrowserHeight();
    // console.log(this.$eventBus, "eventBus");
    this.$eventBus.$on("beenApprovaling", res => {
      console.log(res);
      this.contentReg = res.contentReg;
      this.checkOut.name = res.name;
      this.company = res.supplierName;
      this.checkOut.mobile = res.mobile;
      console.log(this.company);
      // console.log(res, '传值！')
      // console.log(this.checkOut.name, ++this.checkOut.mobile);
    });
  },
  methods: {
    checkSupplierName() {
      this.newCompany.supplierName = this.newCompany.supplierName.replace(
        /[^\u4e00-\u9fa5\(\)\（\）]/g,
        ""
      );
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    // 点击
    goPage() {
      console.log(this.company);
      if (this.newCompany.supplierName) {
        this.checkOut.supplierName = this.newCompany.supplierName;
        this.temporyName = this.newCompany.supplierName;
        this.newCompany.supplierName = "";
      }
      if (!this.checkOut.supplierName) {
        this.$message({
          showClose: true,
          message: "请填写公司全称",
          type: "warning",
          offset: this.messageHeight
        });
      } else {
        let checkName = /^[\u4e00-\u9fa5\(\)\（\）]+$/;
        if (!checkName.test(this.checkOut.supplierName)) {
          this.$message({
            showClose: true,
            message: "请填写正确的公司全称",
            type: "warning",
            offset: this.messageHeight
          });
          return false;
        }
        this.$eventBus.$on("msg", res => {
          console.log(res, "-==-=");
          this.checkOut.name = res.name;
          this.checkOut.mobile = res.mobile;
        });
        this.checkOut.isShowLoading = true;
        this.checkOut.loadingMessage = "注册中,请稍等...";
        // this.checkOut.supplierName = this.newCompany.supplierName;
        getReguser(this.checkOut).then(res => {
          console.log(res, "=-=-=-=-=");
          if (res.data.data.flag !== "") {
            if (res.data.data.flag === "1") {
              console.log("jinlai");
              this.$emit("approval", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile,
                contentReg:
                  "已提交了开店申请，请等待审批结果通过后，再向合作单位发起合作申请，感谢您的申请。"
              };
              this.$eventBus.$emit("beenApprovaling", jsonData);
            } else {
              console.log("jinlai");
              this.$emit("approval", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile,
                contentReg: "正在合作申请中，不能重复申请。"
              };
              this.$eventBus.$emit("beenApprovaling", jsonData);
            }
          } else {
            if (res.data.data.exist === true) {
              this.$emit("isExist", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile
              };
              this.$eventBus.$emit("beenReg", jsonData);
            } else {
              getCompany({
                mobile: this.checkOut.mobile,
                supplierName: this.checkOut.supplierName,
                // supplierName: "北京国际信托有限公司",
                isShowLoading: true
              }).then(res => {
                if (res.data.code === "0") {
                  this.$emit("isExist", {
                    flag: false,
                    name: this.checkOut.supplierName
                  });
                  let jsonData = {
                    name: this.checkOut.name,
                    supplierName: this.checkOut.supplierName,
                    contactId: res.data.data.contactId,
                    mobile: this.checkOut.mobile
                  };
                  this.$eventBus.$emit("supplierName", jsonData);
                }
              });
            }
          }
        });
        // getCheckInfo(this.newCompany).then(res => {
        //   if (res.data.exist) {
        //     this.$emit("isExist", {
        //       flag: true,
        //       name: this.newCompany.supplierName
        //     });
        //   } else {
        //     this.$emit("isExist", {
        //       flag: false,
        //       name: this.newCompany.supplierName
        //     });
        //   }
        // });
        // this.$router.push({ path: "/subFastReg/regNewCompany" });
      }
    }
  }
};
</script>

<style scoped>
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
.title {
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.content {
  width: 1180px;
  min-height: calc(100vh - 290px);
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
}
.mainFlex {
  display: flex;
  justify-content: flex-start;
  height: 100%;
  flex-flow: column;
}
.fastReg {
  width: 100% !important;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  margin-bottom: 20px;
  height: 28px;
  width: 100px;
}
.regUpload {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}
.errorbtn {
  display: none;
  position: absolute;
}
.text {
  width: 500px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 40px;
  padding-left: 10px;
  margin-bottom: 30px;
}
.yourCompany {
  font-size: 13px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  width: 500px;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
  margin-bottom: 50px;
}
:-ms-input-placeholder .text {
  color: rgba(151, 151, 151, 1);
  /* font-size: 12px;
  font-family: Arial; */
}
::-webkit-input-placeholder {
  color: rgba(151, 151, 151, 1);
}
:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(151, 151, 151, 1);
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(151, 151, 151, 1);
}
:-ms-input-placeholder {
  color: rgba(151, 151, 151, 1);
}
</style>
